<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part">Part I</h2>
<p class="prt"><i>“He who rules by virtue is the pole star. He is the unwavering pivot. All others move around him.” —</i> Confucius</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?3bdda8d2